// B7-7: 已绑 OAuth 账号管理(zPcq8)
// pen frames: dogdisk-user.pen # zPcq8
import { Spinner } from '@dogdisk/shared'
import { AppLayout } from '../../components/app-layout'
import { MobileScreen, TopBar } from '../../components/mobile-screen'
import { useMyOAuthAccounts, useUnbindOAuthAccount } from '../../_lib/b7-api'

export function OAuthBindingsPage() {
  const { data, isLoading } = useMyOAuthAccounts()
  const unbind = useUnbindOAuthAccount()

  const onUnbind = async (id: string) => {
    if (!confirm('确定解除此社交账号绑定?')) return
    await unbind.mutateAsync({ id })
  }

  return (
    <AppLayout>
      <MobileScreen>
        <TopBar title="社交账号绑定" />
        <div className="p-4">
          <div className="rounded-lg border bg-white p-4">
            <h2 className="mb-3 text-base font-medium">已绑社交账号</h2>
            {isLoading ? (
              <Spinner />
            ) : (
              <ul className="divide-y">
                {(data?.accounts ?? []).map((a) => (
                  <li key={a.id} className="flex items-center justify-between py-3 text-sm">
                    <div>
                      <p className="font-medium uppercase">{a.provider}</p>
                      <p className="text-xs text-gray-500">subject: {a.subject.slice(0, 24)}…</p>
                    </div>
                    <button onClick={() => onUnbind(a.id)} className="text-xs text-red-500">
                      解绑
                    </button>
                  </li>
                ))}
                {data?.accounts?.length === 0 && (
                  <li className="py-4 text-center text-sm text-gray-400">未绑任何社交账号</li>
                )}
              </ul>
            )}
          </div>
          <p className="mt-3 text-xs text-gray-500">
            登录页可使用 Google / GitHub 一键登录绑定;一个 user 一个 provider 仅可绑 1 个账号。
          </p>
        </div>
      </MobileScreen>
    </AppLayout>
  )
}
